
import { deleteInterestCompany, getInterestCompanyList } from '@/api/interestCompany';
import { IInterestCompany } from '@/types';
import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'HomepageInterestSetting',
})
export default class extends Vue {
  mounted() {
    this.getInterestCompanyList();
  }

  private interestCompanyList: IInterestCompany[] = [];

  private getInterestCompanyList() {
    getInterestCompanyList(this.$route.params.nickname).then((res) => {
      this.interestCompanyList = res.data;
    });
  }

  private handleClickCompany(interestCompany: IInterestCompany) {
    if (window.confirm(`정말 ${interestCompany.companyName}을(를) 관심기업에서 제거하시겠습니까?`)) {
      deleteInterestCompany(interestCompany.uid).then(() => {
        const index = this.interestCompanyList.indexOf(interestCompany);
        alert(`${interestCompany.companyName}가 관심기업에서 제거됐습니다.`);
        this.interestCompanyList.splice(index, 1);
      });
    }
  }
}
